"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _StyledIcons = require("./StyledIcons");

var _add = _interopRequireDefault(require("../assets/icons/add.svg"));

var _addToGallery_veryDarkGrey = _interopRequireDefault(require("../assets/icons/addToGallery_veryDarkGrey.svg"));

var _avatar_empty = _interopRequireDefault(require("../assets/icons/avatar_empty.svg"));

var _calendar_veryDarkGrey = _interopRequireDefault(require("../assets/icons/calendar_veryDarkGrey.svg"));

var _camera_veryDarkGrey = _interopRequireDefault(require("../assets/icons/camera_veryDarkGrey.svg"));

var _cameraLens_veryDarkGrey = _interopRequireDefault(require("../assets/icons/cameraLens_veryDarkGrey.svg"));

var _checkmark_veryDarkGrey = _interopRequireDefault(require("../assets/icons/checkmark_veryDarkGrey.svg"));

var _chevronDown = _interopRequireDefault(require("../assets/icons/chevronDown.svg"));

var _chevronLeft = _interopRequireDefault(require("../assets/icons/chevronLeft.svg"));

var _chevronRight = _interopRequireDefault(require("../assets/icons/chevronRight.svg"));

var _chevronUp = _interopRequireDefault(require("../assets/icons/chevronUp.svg"));

var _clock = _interopRequireDefault(require("../assets/icons/clock.svg"));

var _close = _interopRequireDefault(require("../assets/icons/close.svg"));

var _comment_veryDarkGrey = _interopRequireDefault(require("../assets/icons/comment_veryDarkGrey.svg"));

var _community = _interopRequireDefault(require("../assets/icons/community.svg"));

var _contract = _interopRequireDefault(require("../assets/icons/contract.svg"));

var _copyright = _interopRequireDefault(require("../assets/icons/copyright.svg"));

var _crown = _interopRequireDefault(require("../assets/icons/crown.svg"));

var _discover = _interopRequireDefault(require("../assets/icons/discover.svg"));

var _discover_active = _interopRequireDefault(require("../assets/icons/discover_active.svg"));

var _errorSign = _interopRequireDefault(require("../assets/icons/errorSign.svg"));

var _expand = _interopRequireDefault(require("../assets/icons/expand.svg"));

var _exposure = _interopRequireDefault(require("../assets/icons/exposure.svg"));

var _external_site = _interopRequireDefault(require("../assets/icons/external_site.svg"));

var _edit_veryDarkGrey = _interopRequireDefault(require("../assets/icons/edit_veryDarkGrey.svg"));

var _editorsChoice_veryDarkGrey = _interopRequireDefault(require("../assets/icons/editorsChoice_veryDarkGrey.svg"));

var _facebook_veryDarkGrey = _interopRequireDefault(require("../assets/icons/facebook_veryDarkGrey.svg"));

var _facebook_logo_circle = _interopRequireDefault(require("../assets/icons/facebook_logo_circle.svg"));

var _flag_veryDarkGrey = _interopRequireDefault(require("../assets/icons/flag_veryDarkGrey.svg"));

var _fresh_veryDarkGrey = _interopRequireDefault(require("../assets/icons/fresh_veryDarkGrey.svg"));

var _galleries = _interopRequireDefault(require("../assets/icons/galleries.svg"));

var _google_logo_colored_G = _interopRequireDefault(require("../assets/icons/google_logo_colored_G.svg"));

var _googlePlus = _interopRequireDefault(require("../assets/icons/googlePlus.svg"));

var _hamburgerMenu = _interopRequireDefault(require("../assets/icons/hamburgerMenu.svg"));

var _heart = _interopRequireDefault(require("../assets/icons/heart.svg"));

var _homefeed = _interopRequireDefault(require("../assets/icons/homefeed.svg"));

var _homefeed_active = _interopRequireDefault(require("../assets/icons/homefeed_active.svg"));

var _info = _interopRequireDefault(require("../assets/icons/info.svg"));

var _instagram = _interopRequireDefault(require("../assets/icons/instagram.svg"));

var _location_veryDarkGrey = _interopRequireDefault(require("../assets/icons/location_veryDarkGrey.svg"));

var _lockClosed_veryDarkGrey = _interopRequireDefault(require("../assets/icons/lockClosed_veryDarkGrey.svg"));

var _logged_out_user = _interopRequireDefault(require("../assets/icons/logged_out_user.svg"));

var _logo = _interopRequireDefault(require("../assets/logo/logo.svg"));

var _mail = _interopRequireDefault(require("../assets/icons/mail.svg"));

var _messenger_veryDarkGrey = _interopRequireDefault(require("../assets/icons/messenger_veryDarkGrey.svg"));

var _notification = _interopRequireDefault(require("../assets/icons/notification.svg"));

var _notification_active = _interopRequireDefault(require("../assets/icons/notification_active.svg"));

var _overflowMenu = _interopRequireDefault(require("../assets/icons/overflowMenu.svg"));

var _overflowMenu_solid = _interopRequireDefault(require("../assets/icons/overflowMenu_solid.svg"));

var _photo = _interopRequireDefault(require("../assets/icons/photo.svg"));

var _pig = _interopRequireDefault(require("../assets/icons/pig.svg"));

var _pinterest_veryDarkGrey = _interopRequireDefault(require("../assets/icons/pinterest_veryDarkGrey.svg"));

var _popular_veryDarkGrey = _interopRequireDefault(require("../assets/icons/popular_veryDarkGrey.svg"));

var _quote = _interopRequireDefault(require("../assets/icons/quote.svg"));

var _rocket = _interopRequireDefault(require("../assets/icons/rocket.svg"));

var _search = _interopRequireDefault(require("../assets/icons/search.svg"));

var _settings_veryDarkGrey = _interopRequireDefault(require("../assets/icons/settings_veryDarkGrey.svg"));

var _share_veryDarkGrey = _interopRequireDefault(require("../assets/icons/share_veryDarkGrey.svg"));

var _studio = _interopRequireDefault(require("../assets/icons/studio.svg"));

var _tilda_black = _interopRequireDefault(require("../assets/icons/tilda_black.svg"));

var _tilda_white = _interopRequireDefault(require("../assets/icons/tilda_white.svg"));

var _trash_veryDarkGrey = _interopRequireDefault(require("../assets/icons/trash_veryDarkGrey.svg"));

var _trendsetters = _interopRequireDefault(require("../assets/icons/trendsetters.svg"));

var _trophy = _interopRequireDefault(require("../assets/icons/trophy.svg"));

var _twitter_veryDarkGrey = _interopRequireDefault(require("../assets/icons/twitter_veryDarkGrey.svg"));

var _upcoming_veryDarkGrey = _interopRequireDefault(require("../assets/icons/upcoming_veryDarkGrey.svg"));

var _uploader = _interopRequireDefault(require("../assets/icons/uploader.svg"));

var _uploader_active = _interopRequireDefault(require("../assets/icons/uploader_active.svg"));

var _user = _interopRequireDefault(require("../assets/icons/user.svg"));

var _workshops = _interopRequireDefault(require("../assets/icons/workshops.svg"));

var _play = _interopRequireDefault(require("../assets/icons/play.svg"));

var _pause = _interopRequireDefault(require("../assets/icons/pause.svg"));

var _quest_trophy = _interopRequireDefault(require("../assets/icons/quest_trophy.svg"));

var _quest_trophy_winner = _interopRequireDefault(require("../assets/icons/quest_trophy_winner.svg"));

var _resource_trophy = _interopRequireDefault(require("../assets/icons/resource_trophy.svg"));

var _stats = _interopRequireDefault(require("../assets/icons/stats.svg"));

var _build = _interopRequireDefault(require("../assets/icons/build.svg"));

var _loh_editors = _interopRequireDefault(require("../assets/icons/loh_editors.svg"));

var _loh_quests_trophy = _interopRequireDefault(require("../assets/icons/loh_quests_trophy.svg"));

var _loh_licensing_crown = _interopRequireDefault(require("../assets/icons/loh_licensing_crown.svg"));

var _licensing_sticker = _interopRequireDefault(require("../assets/icons/licensing_sticker.svg"));

var _facebook_solid = _interopRequireDefault(require("../assets/icons/facebook_solid.svg"));

var _instagram_solid = _interopRequireDefault(require("../assets/icons/instagram_solid.svg"));

var _pinterest_solid = _interopRequireDefault(require("../assets/icons/pinterest_solid.svg"));

var _twitter_solid = _interopRequireDefault(require("../assets/icons/twitter_solid.svg"));

var _excluded = ["src", "add", "addToGallery", "avatarEmpty", "badge", "build", "calendar", "camera", "cameraLens", "checkmark", "chevronDown", "chevronLeft", "chevronRight", "chevronUp", "clock", "close", "comment", "community", "contract", "copyright", "crown", "discover", "discoverActive", "expand", "exposure", "externalSite", "edit", "editorsChoice", "errorSign", "facebook", "facebookCircle", "facebookSolid", "flag", "fresh", "galleries", "googleColoredG", "googlePlus", "hamburgerMenu", "heart", "homefeed", "homefeedActive", "info", "instagram", "instagramSolid", "location", "lockClosed", "loggedOutUser", "logo", "mail", "lohEditors", "lohQuests", "lohLicensingCrown", "messenger", "notification", "notificationActive", "overflowMenu", "overflowMenuSolid", "photo", "pig", "pinterest", "pinterestSolid", "popular", "quote", "rocket", "search", "settings", "share", "stats", "studio", "tildeBlack", "tildeWhite", "trash", "trendsetters", "trophy", "touchArea", "twitter", "twitterSolid", "upcoming", "upload", "uploadActive", "user", "workshops", "play", "pause", "questTrophy", "questTrophyWinner", "resourceTrophy", "licensingSticker"];

function InlineSvgIcon(_ref) {
  var src = _ref.src,
      add = _ref.add,
      addToGallery = _ref.addToGallery,
      avatarEmpty = _ref.avatarEmpty,
      badge = _ref.badge,
      build = _ref.build,
      calendar = _ref.calendar,
      camera = _ref.camera,
      cameraLens = _ref.cameraLens,
      checkmark = _ref.checkmark,
      chevronDown = _ref.chevronDown,
      chevronLeft = _ref.chevronLeft,
      chevronRight = _ref.chevronRight,
      chevronUp = _ref.chevronUp,
      clock = _ref.clock,
      close = _ref.close,
      comment = _ref.comment,
      community = _ref.community,
      contract = _ref.contract,
      copyright = _ref.copyright,
      crown = _ref.crown,
      discover = _ref.discover,
      discoverActive = _ref.discoverActive,
      expand = _ref.expand,
      exposure = _ref.exposure,
      externalSite = _ref.externalSite,
      edit = _ref.edit,
      editorsChoice = _ref.editorsChoice,
      errorSign = _ref.errorSign,
      facebook = _ref.facebook,
      facebookCircle = _ref.facebookCircle,
      facebookSolid = _ref.facebookSolid,
      flag = _ref.flag,
      fresh = _ref.fresh,
      galleries = _ref.galleries,
      googleColoredG = _ref.googleColoredG,
      googlePlus = _ref.googlePlus,
      hamburgerMenu = _ref.hamburgerMenu,
      heart = _ref.heart,
      homefeed = _ref.homefeed,
      homefeedActive = _ref.homefeedActive,
      info = _ref.info,
      instagram = _ref.instagram,
      instagramSolid = _ref.instagramSolid,
      location = _ref.location,
      lockClosed = _ref.lockClosed,
      loggedOutUser = _ref.loggedOutUser,
      logo = _ref.logo,
      mail = _ref.mail,
      lohEditors = _ref.lohEditors,
      lohQuests = _ref.lohQuests,
      lohLicensingCrown = _ref.lohLicensingCrown,
      messenger = _ref.messenger,
      notification = _ref.notification,
      notificationActive = _ref.notificationActive,
      overflowMenu = _ref.overflowMenu,
      overflowMenuSolid = _ref.overflowMenuSolid,
      photo = _ref.photo,
      pig = _ref.pig,
      pinterest = _ref.pinterest,
      pinterestSolid = _ref.pinterestSolid,
      popular = _ref.popular,
      quote = _ref.quote,
      rocket = _ref.rocket,
      search = _ref.search,
      settings = _ref.settings,
      share = _ref.share,
      stats = _ref.stats,
      studio = _ref.studio,
      tildeBlack = _ref.tildeBlack,
      tildeWhite = _ref.tildeWhite,
      trash = _ref.trash,
      trendsetters = _ref.trendsetters,
      trophy = _ref.trophy,
      touchArea = _ref.touchArea,
      twitter = _ref.twitter,
      twitterSolid = _ref.twitterSolid,
      upcoming = _ref.upcoming,
      upload = _ref.upload,
      uploadActive = _ref.uploadActive,
      user = _ref.user,
      workshops = _ref.workshops,
      play = _ref.play,
      pause = _ref.pause,
      questTrophy = _ref.questTrophy,
      questTrophyWinner = _ref.questTrophyWinner,
      resourceTrophy = _ref.resourceTrophy,
      licensingSticker = _ref.licensingSticker,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var svgSrc = src || add && _add["default"] || addToGallery && _addToGallery_veryDarkGrey["default"] || avatarEmpty && _avatar_empty["default"] || build && _build["default"] || calendar && _calendar_veryDarkGrey["default"] || camera && _camera_veryDarkGrey["default"] || cameraLens && _cameraLens_veryDarkGrey["default"] || checkmark && _checkmark_veryDarkGrey["default"] || chevronDown && _chevronDown["default"] || chevronLeft && _chevronLeft["default"] || chevronRight && _chevronRight["default"] || chevronUp && _chevronUp["default"] || clock && _clock["default"] || close && _close["default"] || comment && _comment_veryDarkGrey["default"] || community && _community["default"] || contract && _contract["default"] || copyright && _copyright["default"] || crown && _crown["default"] || discover && _discover["default"] || discoverActive && _discover_active["default"] || expand && _expand["default"] || exposure && _exposure["default"] || externalSite && _external_site["default"] || edit && _edit_veryDarkGrey["default"] || errorSign && _errorSign["default"] || facebook && _facebook_veryDarkGrey["default"] || facebookCircle && _facebook_logo_circle["default"] || facebookSolid && _facebook_solid["default"] || flag && _flag_veryDarkGrey["default"] || galleries && _galleries["default"] || googleColoredG && _google_logo_colored_G["default"] || googlePlus && _googlePlus["default"] || hamburgerMenu && _hamburgerMenu["default"] || heart && _heart["default"] || homefeed && _homefeed["default"] || homefeedActive && _homefeed_active["default"] || info && _info["default"] || instagram && _instagram["default"] || instagramSolid && _instagram_solid["default"] || location && _location_veryDarkGrey["default"] || lockClosed && _lockClosed_veryDarkGrey["default"] || loggedOutUser && _logged_out_user["default"] || logo && _logo["default"] || mail && _mail["default"] || lohEditors && _loh_editors["default"] || lohQuests && _loh_quests_trophy["default"] || lohLicensingCrown && _loh_licensing_crown["default"] || messenger && _messenger_veryDarkGrey["default"] || notification && _notification["default"] || notificationActive && _notification_active["default"] || overflowMenu && _overflowMenu["default"] || overflowMenuSolid && _overflowMenu_solid["default"] || play && _play["default"] || pause && _pause["default"] || photo && _photo["default"] || pig && _pig["default"] || pinterest && _pinterest_veryDarkGrey["default"] || pinterestSolid && _pinterest_solid["default"] || questTrophy && _quest_trophy["default"] || questTrophyWinner && _quest_trophy_winner["default"] || resourceTrophy && _resource_trophy["default"] || quote && _quote["default"] || rocket && _rocket["default"] || search && _search["default"] || settings && _settings_veryDarkGrey["default"] || share && _share_veryDarkGrey["default"] || stats && _stats["default"] || studio && _studio["default"] || tildeBlack && _tilda_black["default"] || tildeWhite && _tilda_white["default"] || trash && _trash_veryDarkGrey["default"] || trendsetters && _trendsetters["default"] || trophy && _trophy["default"] || twitter && _twitter_veryDarkGrey["default"] || twitterSolid && _twitter_solid["default"] || user && _user["default"] || upload && _uploader["default"] || uploadActive && _uploader_active["default"] || workshops && _workshops["default"] || badge === 'editorsChoice' && _editorsChoice_veryDarkGrey["default"] || badge === 'fresh' && _fresh_veryDarkGrey["default"] || badge === 'popular' && _popular_veryDarkGrey["default"] || badge === 'upcoming' && _upcoming_veryDarkGrey["default"] || licensingSticker && _licensing_sticker["default"] || null;
  return /*#__PURE__*/_react["default"].createElement(_StyledIcons.StyledIconWrapper, (0, _extends2["default"])({
    location: location
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    cacheRequests: true,
    src: svgSrc,
    uniquifyIDs: true
  }), touchArea && /*#__PURE__*/_react["default"].createElement(_StyledIcons.IconTouchArea, rest));
}

InlineSvgIcon.defaultProps = {
  src: null,
  badge: null,
  add: false,
  addToGallery: false,
  avatarEmpty: false,
  build: false,
  calendar: false,
  camera: false,
  cameraLens: false,
  checkmark: false,
  chevronDown: false,
  chevronLeft: false,
  chevronRight: false,
  chevronUp: false,
  clock: false,
  close: false,
  comment: false,
  community: false,
  contract: false,
  copyright: false,
  crown: false,
  discover: false,
  discoverActive: false,
  edit: false,
  editorsChoice: false,
  errorSign: false,
  expand: false,
  exposure: false,
  externalSite: false,
  facebook: false,
  facebookCircle: false,
  facebookSolid: false,
  flag: false,
  fresh: false,
  galleries: false,
  googleColoredG: false,
  googlePlus: false,
  hamburgerMenu: false,
  heart: false,
  homefeed: false,
  homefeedActive: false,
  info: false,
  instagram: false,
  instagramSolid: false,
  location: false,
  lockClosed: false,
  loggedOutUser: false,
  logo: false,
  mail: false,
  lohEditors: false,
  lohQuests: false,
  lohQuestTrophy: false,
  lohLicensingCrown: false,
  notification: false,
  notificationActive: false,
  messenger: false,
  overflowMenu: false,
  overflowMenuSolid: false,
  play: false,
  pause: false,
  photo: false,
  pig: false,
  pinterest: false,
  pinterestSolid: false,
  popular: false,
  questTrophy: false,
  questTrophyWinner: false,
  resourceTrophy: false,
  quote: false,
  rocket: false,
  search: false,
  settings: false,
  share: false,
  stats: false,
  studio: false,
  tildeBlack: false,
  tildeWhite: false,
  touchArea: false,
  trash: false,
  trendsetters: false,
  trophy: false,
  twitter: false,
  twitterSolid: false,
  upcoming: false,
  user: false,
  upload: false,
  uploadActive: false,
  workshops: false,
  licensingSticker: false
};
InlineSvgIcon.propTypes = {
  src: _propTypes["default"].string,
  badge: _propTypes["default"].string,
  add: _propTypes["default"].bool,
  addToGallery: _propTypes["default"].bool,
  avatarEmpty: _propTypes["default"].bool,
  build: _propTypes["default"].bool,
  calendar: _propTypes["default"].bool,
  camera: _propTypes["default"].bool,
  cameraLens: _propTypes["default"].bool,
  checkmark: _propTypes["default"].bool,
  chevronDown: _propTypes["default"].bool,
  chevronLeft: _propTypes["default"].bool,
  chevronRight: _propTypes["default"].bool,
  chevronUp: _propTypes["default"].bool,
  clock: _propTypes["default"].bool,
  close: _propTypes["default"].bool,
  comment: _propTypes["default"].bool,
  community: _propTypes["default"].bool,
  contract: _propTypes["default"].bool,
  copyright: _propTypes["default"].bool,
  crown: _propTypes["default"].bool,
  discover: _propTypes["default"].bool,
  discoverActive: _propTypes["default"].bool,
  edit: _propTypes["default"].bool,
  editorsChoice: _propTypes["default"].bool,
  errorSign: _propTypes["default"].bool,
  expand: _propTypes["default"].bool,
  exposure: _propTypes["default"].bool,
  externalSite: _propTypes["default"].bool,
  facebook: _propTypes["default"].bool,
  facebookCircle: _propTypes["default"].bool,
  facebookSolid: _propTypes["default"].bool,
  flag: _propTypes["default"].bool,
  fresh: _propTypes["default"].bool,
  galleries: _propTypes["default"].bool,
  googleColoredG: _propTypes["default"].bool,
  googlePlus: _propTypes["default"].bool,
  hamburgerMenu: _propTypes["default"].bool,
  heart: _propTypes["default"].bool,
  homefeed: _propTypes["default"].bool,
  homefeedActive: _propTypes["default"].bool,
  info: _propTypes["default"].bool,
  instagram: _propTypes["default"].bool,
  instagramSolid: _propTypes["default"].bool,
  location: _propTypes["default"].bool,
  lockClosed: _propTypes["default"].bool,
  loggedOutUser: _propTypes["default"].bool,
  logo: _propTypes["default"].bool,
  mail: _propTypes["default"].bool,
  lohEditors: _propTypes["default"].bool,
  lohLicensingCrown: _propTypes["default"].bool,
  lohQuests: _propTypes["default"].bool,
  lohQuestTrophy: _propTypes["default"].bool,
  messenger: _propTypes["default"].bool,
  notification: _propTypes["default"].bool,
  notificationActive: _propTypes["default"].bool,
  overflowMenu: _propTypes["default"].bool,
  overflowMenuSolid: _propTypes["default"].bool,
  play: _propTypes["default"].bool,
  pause: _propTypes["default"].bool,
  photo: _propTypes["default"].bool,
  pig: _propTypes["default"].bool,
  pinterest: _propTypes["default"].bool,
  pinterestSolid: _propTypes["default"].bool,
  popular: _propTypes["default"].bool,
  questTrophy: _propTypes["default"].bool,
  questTrophyWinner: _propTypes["default"].bool,
  resourceTrophy: _propTypes["default"].bool,
  quote: _propTypes["default"].bool,
  rocket: _propTypes["default"].bool,
  search: _propTypes["default"].bool,
  settings: _propTypes["default"].bool,
  share: _propTypes["default"].bool,
  stats: _propTypes["default"].bool,
  studio: _propTypes["default"].bool,
  tildeBlack: _propTypes["default"].bool,
  tildeWhite: _propTypes["default"].bool,
  touchArea: _propTypes["default"].bool,
  trash: _propTypes["default"].bool,
  trendsetters: _propTypes["default"].bool,
  trophy: _propTypes["default"].bool,
  twitter: _propTypes["default"].bool,
  twitterSolid: _propTypes["default"].bool,
  upcoming: _propTypes["default"].bool,
  user: _propTypes["default"].bool,
  upload: _propTypes["default"].bool,
  uploadActive: _propTypes["default"].bool,
  workshops: _propTypes["default"].bool,
  licensingSticker: _propTypes["default"].bool
};
var _default = InlineSvgIcon;
exports["default"] = _default;